import { render } from "./NotFound.vue?vue&type=template&id=1696d061"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=1696d061&lang=css"
script.render = render

export default script